import React from 'react';
import {Typography} from '@mui/material';
import {Config} from 'olympe';

/**
 * Text with link to download the template document for applying to RF reason code
 *
 * @param {Object} props
 * @return {JSX.Element}
 * @constructor
 */
export const RFDocumentTemplateLink = (props) => {
    return <Typography style={{color: 'rgb(128,128,128)', ...props.style}}>
        <a href={Config.getParameter('uiappValues.rf_template_url')} target="_blank" rel="noreferrer">Template document</a> for reason code.
    </Typography>;
};
